export default __webpack_public_path__ + "static/media/Tools-barcode-scanner-art.0c34e694.jpeg";